import jwtDecode from "jwt-decode";
import moment from "moment/moment";
import { useCallback, useContext } from "react";
import {
  SESSION_EXPIRE,
  SESSION_TOKEN,
  SESSION_USER,
} from "../../Utils/constants.api";
import { AuthContext } from "../authContext";
import { useDispatch } from "react-redux";
import { filterActions } from "../../store/filter";
import { cartActions } from "../../store/cart";
import { uiActions } from "../../store/ui";

export default function useUser() {
  const { token, setToken, expireAt, setExpireAt } = useContext(AuthContext);
  const dispatch = useDispatch();
  const login = (tokenUser, expire) => {

    localStorage.setItem(SESSION_TOKEN, tokenUser);
    localStorage.setItem(SESSION_EXPIRE, expire);
    setToken((currToken) => tokenUser);
    setExpireAt((currExpire) => expire);
    dispatch(uiActions.toReset());
    
  };

  const logout = () => {
    localStorage.removeItem(SESSION_USER);
    localStorage.removeItem(SESSION_TOKEN);
    localStorage.removeItem(SESSION_EXPIRE);
    localStorage.removeItem("userImage");
    dispatch(filterActions.toReset());
    dispatch(cartActions.toReset());
    dispatch(uiActions.toReset());

    setToken(null);
    setExpireAt(null);
  };

  const isAuth = () => {
    return token && validateExpireTime();
  };

  const getUser = () => {
    try {
      const decode = jwtDecode(token);
      const user = {
        email: decode?.Email,
        emailVerify: decode?.EmailVerify == 1 ? true : false,
        fullName: decode?.FullName,
        id: decode?.Id,
        clientTypeId: decode?.ClientTypeId,
        changePassword: decode?.ChangePassword == 1 ? true : false,
      };
      
      return user;
    } catch (e) {
      return null;
    }
  };

  const validateExpireTime = () => {
    const currentDate = moment();
    const currentExpirationDate = moment(expireAt);
    return currentExpirationDate.isAfter(currentDate);
  };

  return {
    logout,
    login,
    isAuth,
    getUser,
    token,
  };
}
